import { AxiosInstance } from 'axios';

/**
 * API リクエストごとに最新のトークンを取得して、Authorization ヘッダーを付与する。
 * トークンが取得できない場合(ログイン前の API など)は、ヘッダーを付けない。
 *
 * 生成コード(src/api/server)には手を入れず、axios のインスタンスに対して認証を組み込むための関数。
 */
export const attachAuthInterceptor = (
  instance: AxiosInstance,
  getToken: () => Promise<string>,
): number =>
  instance.interceptors.request.use(async (config) => {
    const token = await getToken();
    if (token) {
      config.headers = { ...config.headers, Authorization: `Bearer ${token}` };
    }
    return config;
  });
